import { FC, useState } from 'react';

import { getTradeTabOptions } from 'helpers';
import { MarketTabT } from 'types';

import MainCreateMarketLimitOrder from 'components/mainCreateMarketLimitOrder';
import Tabs from 'elements/tabs';

import './MainCreateOrder.scss';

const MainCreateOrder: FC = () => {
  const tabsOptions: MarketTabT[] = getTradeTabOptions(_t);
  const [currentTab, setCurrentTab] = useState<any>(tabsOptions[1]);
  
  return (
    <div className="main-create-order">
      <div className="main-create-order-header">
        <Tabs data={tabsOptions} currentTab={currentTab} handlerClick={(tab: any) => setCurrentTab(tab)} />
      </div>
      <div className="main-create-order-content">
        <MainCreateMarketLimitOrder orderType={currentTab.value} />
      </div>
    </div>
  );
};

export default MainCreateOrder;
